import * as ACTION_TYPES from "./action-types";

/**
 * Show or hide the team settings slide-out panel (mounted in Sidebar.js).
 * @param {Object} data
 * @param {boolean} data.showTeamSettingSidebar
 */
export const setShowTeamSettingSidebar = (data) => {
  return {
    type: ACTION_TYPES.TOGGLE_TEAM_SETTING_SIDEBAR,
    payload: data,
  };
};

/**
 * Expanded PanelBar section ids for the team settings slide-out.
 * @param {string[]} sectionIds
 */
export const setTeamSettingSidebarExpanded = (sectionIds) => {
  return {
    type: ACTION_TYPES.SET_TEAM_SETTING_SIDEBAR_EXPANDED,
    payload: sectionIds,
  };
};
